import moment from 'moment'

const getOptions = ({
    categories,
    customTooltip,
    dryStorageCapacity,
    theme,
}: {
    categories: string[],
    customTooltip: (args: any) => string,
    dryStorageCapacity: number,
    theme: Record<string, any>,
}) => {
    const defineColor = ({
        value,
    }) => {
        return Math.round((value / (dryStorageCapacity || 100)) * 100) <= 100
            ? theme.palette.common.yellow
            : theme.palette.common.red
    }

    return {
        legend: {
            horizontalAlign: 'left',
        } as ApexLegend,
        tooltip: {
            custom: customTooltip,
        },
        yaxis: [{
            labels: {
                formatter(val: number) {
                    return `${Math.round((val / (dryStorageCapacity || 100)) * 100)}%` // to avoid error if dryStorageCapacity is zero
                },
            },
        }],
        chart: {
            id: 'basic-bar',
            toolbar: {
                show: true,
                offsetX: -60,
                offsetY: 0,
                tools: {
                    download: '<img src="/assets/images/download_button.svg" width="24px" height="24px" alt="download"/>',
                },
            },
        },
        xaxis: {
            categories,
            labels: {
                formatter(value) {
                    return moment(value, 'DD.MM.YYYY').format('DD.MM')
                },
            },
        },
        colors: [defineColor],
        dataLabels: {
            enabled: false,
        },
        grid: {
            padding: {
                right: 70,
                top: 20,
            },
            xaxis: {
                lines: {
                    show: true,
                },
            },
            strokeDashArray: 7,
        },
    }
}

export default getOptions
